<section class="tp-error-area pt-110 pb-110">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-xl-6 col-lg-8 col-md-10">
                <div class="tp-error-content text-center">
                    <h3 class="tp-error-title">Please Verify Your Email</h3>
                </div>
            </div>
        </div>
    </div>
</section>
